var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationsMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 443.3 443.3",
    style: {
      enableBackground: "new 0 0 443.3 443.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.4,72c-19.5,0-35.4,15.9-35.4,35.4s15.9,35.4,35.4,35.4s35.4-15.9,35.4-35.4S229,72,209.4,72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4,13c-52.1,0-94.5,42.4-94.5,94.5c0,17.9,5,35.3,14.5,50.3l79.9,127.6l79.9-127.6c9.5-15.1,14.5-32.5,14.5-50.3 C303.9,55.4,261.5,13,209.4,13z M209.4,166.5c-32.5,0-59-26.5-59-59s26.5-59,59-59s59,26.5,59,59S242,166.5,209.4,166.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152,416h114.9l-9.1-71.6h-97L152,416z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.8,320.8h40.1l-33.4-53L163.8,320.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.6,320.8h93l-29.5-70.8h-72.6L278.6,320.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,320.8H140l8.9-70.8h-72L47.3,320.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215,320.8h39.7l-6.7-52.4L215,320.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137,344.4H37.5L7.9,416h120.2L137,344.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M381.4,344.4h-99.8l9.1,71.6h120.3L381.4,344.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsMap);
export default __webpack_public_path__ + "static/media/locations-map.f9e44b89.svg";
export { ForwardRef as ReactComponent };